import * as React from "react";
import PageLayout from "../../components/Layout/PageLayout";
import {Helmet} from "react-helmet";
import {useLocation} from "react-router-dom";

const ManageCookies = () => {
	const location = useLocation();

	return (
		<>
			<Helmet>
				<title>Z! Memes DMCA Copyright Policy | Zikoko! Memes</title>
				<meta name="description" content="Zikoko Memes is your go-to search engine for relatable and culturally relevant memes, created by and for black people and Africans." />
				<link rel="canonical" href={process.env.REACT_APP_BASE_URL + location.pathname} />
				<meta property="og:title" content="Z! Memes DMCA Copyright Policy | Zikoko! Memes"/>
				<meta property="og:url" content={process.env.REACT_APP_BASE_URL + location.pathname}/>
				<meta property="og:image" content={`${process.env.REACT_APP_BASE_URL}/images/zikoko-memes-img.jpg`} />
				<meta property="og:description" content="Zikoko Memes is your go-to search engine for relatable and culturally relevant memes, created by and for black people and Africans."/>
			</Helmet>
			<PageLayout title="Manage Cookies" updated="">
				<section className="grid grid-page-content page-content">
					<ul className="page-anchors">
						<li><a href="#introduction">Introduction</a></li>
						<li><a href="#user-submission">User Submissions</a></li>
						<li><a href="#discussion-forum">User Discussion Lists and Forums</a></li>
						<li><a href="#personal-information">Use of Personally Identifiable Information</a></li>
						<li><a href="#indemnification">Indemnification</a></li>
						<li><a href="#termination">Termination</a></li>
					</ul>
					<div className="page-content-main">
						<div id="introduction">
							<h2>Introduction</h2>
							<p>
								Zikoko Memes is a platform for finding and creating culture relevant memes that people can tap into to participate in trending conversations. As a creator on this platform, we want you to express your creativity by creating, sharing and publishing relatable and appropriate content that can be used by other creators and viewers on the platform. We have created the following guidelines to help you ensure that your content is safe, appropriate and thereby not rejected by our moderators.
							</p>
						</div>
						<div id="information-we-collect">
							<h2>User Submissions</h2>
							<p>The Operators do not want to receive confidential or proprietary information from you through the Website. Any material, information, or other communication you transmit or post (“Contributions”) to the Website will be considered non-confidential.</p>
							<p>All contributions to this site are licensed by you under the MIT License to anyone who wishes to use them, including the Operators.</p>
							<p>If you work for a company or at a University, it’s likely that you’re not the copyright holder of anything you make, even in your free time. Before making contributions to this site, get written permission from your employer.</p>
						</div>
					</div>
				</section>
			</PageLayout>
		</>
	);
}

export default ManageCookies;
